import React, { useContext, useMemo, useRef } from 'react';
import PropTypes from 'prop-types';
import { svgSprite, Tooltip } from '../../../../hybrid/wrappers';
import ReactDOM from 'react-dom';
import ModalDropDown from './ModalDropDown/ModalDropDown';
import css from './TableDropdown.module.scss';
import classnames from 'classnames';
import { UserProfileContext } from '../../../../common/utils/getContext';
import TableDropdownAdmin from '../TableDropDown/TableDropdown';

const TableDropdown = (props) => {
    const { val, alias, activeTr, setActiveTr, refTable, gridName, refTableChild } = props;
    const { adminPage } = useContext(UserProfileContext);
    const modalDropdown = useRef(null);
    const modal = useRef(null);
    const showDropdown = useMemo(() => alias === activeTr, [alias, activeTr]);
    const dataArr = Object.keys(val)
        .sort((a) => (['email', 'phone'].includes(a) ? -1 : 1))
        ?.filter((k) => val[k] && k !== 'showOnlyDots');
    const showOnlyDots = val?.showOnlyDots;
    const isDropdown = useMemo(() => {
        const res = [];
        dataArr.map((item) => {
            if (val[item] !== null) {
                res.push(val[item]);
            }
        });
        return res.length > 0;
    }, [dataArr, val]);

    const ContactImg = (val) => {
        switch (val) {
            case 'email':
                return 'email';
            case 'additional_email':
                return 'email-colored';
            case 'phone':
                return 'phone';
            case 'facebook':
                return 'facebook-colored';
            case 'instagram':
                return 'instagram-colored';
            case 'ok':
                return 'odnoklassniki-colored';
            case 'telegram':
                return 'telegram-colored';
            case 'twitter':
                return 'twitter-colored';
            case 'viber':
                return 'viber-colored';
            case 'vk':
                return 'vkontakte-colored';
            case 'whatsapp':
                return 'whatsapp-colored';
            default:
                return 'phone';
        }
    };

    const firstTwoContacts = dataArr.slice(0, 2);
    const lastContacts = dataArr.slice(2);

    const contactHander = (type, value) => {
        let href = '';

        switch (type) {
            case 'phone': {
                href = `tel:${value}`;
                break;
            }
            case 'email': {
                href = `mailto:${value}`;
                break;
            }
            case 'whatsapp': {
                href = `https://wa.me/${value}`;
                break;
            }
            case 'instagram': {
                href = `https://instagram.com/${value}`;
                break;
            }
            case 'facebook': {
                href = `https://facebook.com/${value}`;
                break;
            }
            case 'telegram': {
                href = `https://t.me/${value}`;
                break;
            }
            case 'twitter': {
                href = `https://twitter.com/${value}`;
                break;
            }
            case 'viber': {
                href = `viber://pa?chatURI=${value}`;
                break;
            }
            case 'tiktok': {
                href = `www.tiktok.com/${value}`;
                break;
            }
            case 'ok': {
                href = `https://ok.ru/${value}`;
                break;
            }
            case 'vk': {
                href = `https://vk.com/${value}`;
                break;
            }
            default:
                break;
        }

        const link = document.createElement('a');
        link.setAttribute('href', href);
        link.setAttribute('target', '_blank');
        link.click();
        link.remove();
    };

    if (adminPage) {
        return <TableDropdownAdmin {...props} />;
    }

    return (
        <div className={css.dropdownWrapper} ref={modalDropdown}>
            {!showOnlyDots &&
                firstTwoContacts?.map((contact) => (
                    <Tooltip
                        compStyle={{ tooltipWrap: css.dropdownBlockRow }}
                        key={contact}
                        disableOnMobile={true}
                        text={val?.[contact]}
                    >
                        <div className={css.dropdownBlockRow} onClick={() => contactHander(contact, val?.[contact])}>
                            {svgSprite(ContactImg(contact), { className: css.contactIcon })}
                        </div>
                    </Tooltip>
                ))}
            {(showOnlyDots ? dataArr : lastContacts) && (showOnlyDots ? dataArr?.length : lastContacts?.length) ? (
                <div
                    key={alias}
                    className={
                        showDropdown && !!isDropdown
                            ? classnames(css.dropdownBlockRow, css.dropdownBlockRowActiveWeb)
                            : css.dropdownBlockRow
                    }
                    onClick={(e) => {
                        e.stopPropagation();
                        setActiveTr(alias !== activeTr ? alias : false);

                        setTimeout(() => {
                            if (modal?.current) {
                                const buttonWidth = modalDropdown.current.getBoundingClientRect().width;
                                const modalWidth = modal.current.getBoundingClientRect().width;
                                modal.current.style.top = `${
                                    modalDropdown?.current?.getBoundingClientRect()?.top -
                                    refTable?.current.getBoundingClientRect()?.top +
                                    modalDropdown?.current?.getBoundingClientRect()?.height
                                }px`;
                                modal.current.style.left = `${
                                    modalDropdown?.current?.getBoundingClientRect()?.left -
                                    refTable?.current.getBoundingClientRect()?.left -
                                    modalWidth +
                                    buttonWidth
                                }px`;
                                modal.current.style.minWidth = `${modalDropdown?.current?.getBoundingClientRect()?.width}px`;
                                modal.current.style.visibility = 'visible';
                            }
                        }, 0);
                    }}
                >
                    {/* {svgSprite('email-colored', { className: css.contactIcon })} */}
                    <p className={css.dropdownItem}>{svgSprite('dots-horisontal')}</p>
                </div>
            ) : null}
            {!!isDropdown &&
                document.getElementById(`${gridName}portalDropdown`) &&
                ReactDOM.createPortal(
                    <ModalDropDown
                        showDropdown={showDropdown}
                        dataArr={showOnlyDots ? dataArr : lastContacts}
                        modal={modal}
                        ContactImg={ContactImg}
                        refTable={refTable}
                        modalDropdown={modalDropdown}
                        refTableChild={refTableChild}
                        contactHander={contactHander}
                    >
                        {val}
                    </ModalDropDown>,
                    document?.getElementById(`${gridName}portalDropdown`)
                )}
        </div>
    );
};

TableDropdown.propTypes = {
    alias: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    activeTr: PropTypes.oneOfType([PropTypes.bool, PropTypes.string, PropTypes.number]),
    setActiveTr: PropTypes.func,
    refTable: PropTypes.object,
    gridName: PropTypes.string,
    refTableChild: PropTypes.object
};

export default TableDropdown;
